export default __webpack_public_path__ + "static/media/Termice.6abcf58a.svg";